import { subject } from '../../../schema';
import { denormalize } from 'normalizr';

export const selectHydrated = (state, id) => denormalize(id, subject, state.entities);

export const selectSubjectOptions = (state) => {
  const subjects = state.entities.subjects;
  return Object.keys(subjects).map(k => ({
    id: k,
    label: subjects[k].name
  }))
};


// WEBPACK FOOTER //
// ./src/redux/modules/subjects/selectors.js